<template>
  <div>
    <PageAllow controller="Licences" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="ma-5">
          <v-spacer />
          <!-- 添加 -->
          <v-btn
            v-if="$permission.permissionAllow('Licences', 'add')"
            small
            color="primary"
            @click.stop="
              currentItem = {};
              dialog = true;
              mode = 'add';
            "
            class="ms-1"
          >
            <v-icon x-small class="pe-1">fa-plus</v-icon>
            {{ $t("Supplier.licences.add") }}
          </v-btn>
        </v-row>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="licences"
            :page.sync="paging.page"
            :options.sync="options"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.code="{ item }">
              <span v-if="item.expired_flg" class="red--text">
                {{ item.code }}
              </span>
              <span v-else>
                {{ item.code }}
              </span>
            </template>
            <template v-slot:item.name="{ item }">
              <span v-if="item.expired_flg" class="red--text">
                {{ item.name }}
              </span>
              <span v-else>
                {{ item.name }}
              </span>
            </template>
            <template v-slot:item.expired_date="{ item }">
              <span v-if="item.expired_flg" class="red--text">
                {{ item.expired_date | formatDate }}
              </span>
              <span v-else>
                {{ item.expired_date | formatDate }}
              </span>
            </template>
            <template v-slot:item.effective_date="{ item }">
              <span v-if="item.expired_flg" class="red--text">
                {{ item.effective_date | formatDate }}
              </span>
              <span v-else>
                {{ item.effective_date | formatDate }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 下载 -->
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Licences', 'index')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="info"
                    class="px-2 me-2"
                    :href="item.file_address"
                    target="_blank"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("Supplier.licences.download") }}
                  </v-btn>
                </template>
                <span>
                  {{ $t("Supplier.licences.download") }}
                </span>
              </v-tooltip>
              <!-- 编辑 -->
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Licences', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="primary"
                    class="px-2 me-2"
                    @click.stop="
                      currentItem = JSON.parse(JSON.stringify(item));
                      dialog = true;
                      mode = 'edit';
                    "
                  >
                    <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                    {{ $t("Supplier.licences.edit") }}
                  </v-btn>
                </template>
                <span>{{ $t("Supplier.licences.edit") }}</span>
              </v-tooltip>
              <!-- 删除 -->
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Licences', 'delete')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="danger"
                    class="px-2 me-2"
                    @click.stop="
                      currentItem = JSON.parse(JSON.stringify(item));
                      deleteDialog = true;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-exclamation</v-icon>
                    {{ $t("Supplier.licences.delete") }}
                  </v-btn>
                </template>
                <span>{{ $t("Supplier.licences.delete") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 删除 -->
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('Supplier.licences.ObjectName')"
      @confirm="
        deleteContainer();
        deleteDialog = false;
      "
    />
    <!-- 新增/编辑弹窗 -->
    <v-dialog persistent v-model="dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("CRUD.info", [$t("Supplier.licences.ObjectName")]) }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row align="center" dense>
                <v-col cols="3" class="text-right">
                  {{ $t("Supplier.licences.code") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Supplier.licences.code')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="currentItem.code"
                      :error-messages="errors"
                      dense
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center" dense>
                <v-col cols="3" class="text-right">
                  {{ $t("Supplier.licences.name") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Supplier.licences.name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="currentItem.name"
                      :error-messages="errors"
                      dense
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center" dense>
                <v-col cols="3" class="text-right">
                  {{
                    $t("Supplier.licences.effective_date") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Supplier.licences.effective_date')"
                    rules="required"
                  >
                    <SearcherDatetime
                      class="my-2"
                      v-model="currentItem.effective_date"
                      type="date"
                      single-line
                      dense
                      hide-details
                      hide-icon
                      required
                      :errors="errors"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center" dense>
                <v-col cols="3" class="text-right">
                  {{
                    $t("Supplier.licences.expired_date") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Supplier.licences.expired_date')"
                    rules="required"
                  >
                    <SearcherDatetime
                      class="my-2"
                      v-model="currentItem.expired_date"
                      type="date"
                      single-line
                      dense
                      hide-details
                      hide-icon
                      required
                      :errors="errors"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center" dense>
                <v-col cols="3" class="text-right">
                  {{ $t("Supplier.licences.file_name") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Supplier.licences.file')"
                    rules="required"
                  >
                    <v-file-input
                      ref="file"
                      show-size
                      persistent-hint
                      :placeholder="$t('Supplier.licences.Placeholder')"
                      v-model="file"
                      :error-messages="errors"
                    >
                    </v-file-input>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" outlined @click="dialog = false">
            {{ $t("$vuetify.abandon") }}
          </v-btn>
          <v-btn color="accent" depressed @click="submit()">
            {{ $t("$vuetify.submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Licences from "@/api/licences";
import DialogDelete from "@/components/plugins/DialogDelete";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import Files from "@/api/files";

export default {
  data: () => ({
    licences: [],
    paging: {},
    currentItem: {},
    initialize: 0,
    deleteDialog: false,
    dialog: false,
    file: null,
    imgRules: [
      (value) =>
        !value || value.size < 10000000 || i18n.t("AccountAds.imgHint"),
    ],
    mode: "",
    options: {},
  }),
  components: {
    Breadcrumbs,
    PageAllow,
    DialogDelete,
    ValidationObserver,
    ValidationProvider,
    SearcherDatetime,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/supplier",
      },
      {
        text: i18n.t("Nav.supplier"),
        disabled: false,
        href: "/supplier",
      },
      {
        text: i18n.t("Nav.licences"),
        disabled: true,
        href: "",
      },
    ],
    headers: () => [
      {
        text: i18n.t("Supplier.licences.code"),
        align: "start",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("Supplier.licences.name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("Supplier.licences.effective_date"),
        align: "start",
        sortable: false,
        value: "effective_date",
      },
      {
        text: i18n.t("Supplier.licences.expired_date"),
        align: "start",
        sortable: false,
        value: "expired_date",
      },
      {
        text: i18n.t("Supplier.licences.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  mounted() {
    this.getLicencesFromAPI();
  },
  methods: {
    getLicencesFromAPI() {
      Licences.fetch(
        Object.assign({}, this.options, { supplier_id: this.$route.params.id })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.licences = response.data.licences;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    // 弹窗 确认删除
    deleteContainer() {
      if (this.currentItem) {
        Licences.Delete(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getLicencesFromAPI();
            }
          }.bind(this)
        );
      }
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      if (this.$refs.file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            if (this.file) {
              let response = await Files.fileUpload(this.file, "licences");
              if (response.data.status.isOK()) {
                this.currentItem.file_name = response.data.data.file_name;
              }
            }
            if (this.mode == "add") {
              Licences.add(
                Object.assign({}, this.currentItem, {
                  supplier_id: this.$route.params.id,
                })
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.dialog = false;
                      this.$refs.observer.reset();
                      this.getLicencesFromAPI();
                      this.$store.dispatch("fullscreenLoadingStop");
                    } else {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            } else if (this.mode == "edit") {
              var data = {
                supplier_id: this.$route.params.id,
                id: this.currentItem.id,
                name: this.currentItem.name,
                effective_date: this.currentItem.effective_date,
                expired_date: this.currentItem.expired_date,
                file_name: this.currentItem.file_name,
                code: this.currentItem.code,
              };
              Licences.edit(data)
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.dialog = false;
                      this.$refs.observer.reset();
                      this.getLicencesFromAPI();
                      this.$store.dispatch("fullscreenLoadingStop");
                    } else {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
            this.$store.dispatch("fullscreenLoadingStop");
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },
  watch: {
    currentItem: {
      handler() {},
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.file = null;
          this.currentItem = {};
          this.$refs.observer.reset();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getLicencesFromAPI();
      },
    },
  },
};
</script>

<style>
</style>